import { AccountInterface, ProviderInterface } from 'starknet';

export function isAccount(
  providerOrAccount: ProviderInterface | AccountInterface,
): providerOrAccount is AccountInterface {
  return (providerOrAccount as AccountInterface).address !== undefined;
}
